// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","links":"Footer_links__q2x7d","info":"Footer_info__2OKti","icons":"Footer_icons__ZW8St","sns":"Footer_sns__K27EF"};